<template>
  <v-list-tile draggable
    :class="[
      'folder',
      'it-hv',
      {
        'blue': isSelecting,
        'lighten-4': isSelecting,
        'grey': isDragovering,
        'lighten-2': isDragovering
      }
    ]"
    @dragstart="dragstart"
    @dragend="dragend"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop.stop.prevent="drop"
    :disabled="!isActive || isLoading">
    <v-list-tile-avatar><font-awesome-icon :icon="['fas', 'folder']" class="blue--text" /></v-list-tile-avatar>
    <v-list-tile-content v-if="$vuetify.breakpoint.smAndUp">
      <v-container grid-list-md class="px-0">
        <v-layout wrap class="transparent">
          <v-flex xs8 class="pa-0">
            <button type="button" @click="open" class="py-0 flex name-link text-truncate" :disabled="$props.status && isTrashed">{{ printName }}</button>
            <div class="px-1 caption">
              <span v-if="isLocked" class="mr-2"><font-awesome-icon :icon="['fas', 'lock']" size="xs" />&nbsp;{{ printAuthor }}</span>
              <span v-if="isSharedDirectory || isShared" class="mr-2"><font-awesome-icon :icon="['fas', 'link']" size="xs" />&nbsp;共有中</span>
            </div>
          </v-flex>
          <v-flex xs2 align-self-center class="caption grey--text text--darken-2 pa-0 text-truncate">{{ printModifiedAt }}</v-flex>
          <v-flex xs2 align-self-center class="caption grey--text text--darken-2 pa-0 text-truncate"></v-flex>
        </v-layout>
      </v-container>
    </v-list-tile-content>
    <v-list-tile-content v-else>
      <v-list-tile-title>
        <button type="button" class="flex name-link text-truncate" :disabled="isTrashed" @click.stop="open">{{ printName }}</button>
      </v-list-tile-title>
      <v-list-tile-sub-title class="caption">{{ printModifiedAt }}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
const DEFAULT = {
  STATUS: {
    LOADING: false,
    SELECTING: false,
    DRAGGING: false,
    DRAGOVERING: false
  }
}
export default {
  name: 'filerFolder',
  props: [
    'cid',
    'authed',
    'shared',
    'trashed',
    'status',
    'item',
    'selectable'
  ],
  components: {
  },
  data () {
    return {
      config: {
        status: {
          loading: DEFAULT.STATUS.LOADING,
          selecting: DEFAULT.STATUS.SELECT,
          dragging: DEFAULT.STATUS.DRAGGING,
          dragovering: DEFAULT.STATUS.DRAGOVERING
        }
      }
    }
  },
  created () {
  },
  methods: {
    state: function (req) {
      if (
        req &&
        req.type &&
        req.status != null
      ) {
        this.$set(this.config.status, req.type, req.status)
      }
    },
    open: function () {
      if (this.$props.item) {
        this.$emit('emit', {
          action: 'open',
          data: this.$props.item
        })
      }
    },
    rename: function () {
      if (this.$props.item) {
        this.$emit('emit', {
          action: 'rename',
          data: this.$props.item
        })
      }
    },
    share: function () {
      if (this.$props.item && this.$props.status) {
        this.$emit('emit', {
          action: 'share',
          data: this.$props.item
        })
      }
    },
    unshare: function () {
      if (this.$props.item && this.$props.status) {
        this.$emit('emit', {
          action: 'unshare',
          data: this.$props.item
        })
      }
    },
    trash: function () {
      if (this.$props.item && this.$props.status) {
        this.$set(this.config.status, 'loading', true)
        this.$emit('emit', {
          action: this.$props.trashed ? 'trash' : 'restore',
          data: this.$props.item
        })
      }
    },
    select: function (e) {
      if (
        this.$props.item &&
        e &&
        e.type &&
        this.$props.selectable
      ) {
        if (e.type === 'mousedown') {
          if (e.metaKey) {
            this.state({
              type: 'selecting',
              status: !this.config.status.selecting
            })
            this.$emit('emit', {
              action: 'select',
              data: {
                item: this.$props.item,
                event: e
              }
            })
          } else if (!this.config.status.selecting) {
            this.state({
              type: 'selecting',
              status: true
            })
            this.$emit('emit', {
              action: 'select',
              data: {
                item: this.$props.item,
                event: e
              }
            })
          }
        } else if (e.type === 'click') {
          if (!this.config.status.dragging) {
            this.state({
              type: 'selecting',
              status: true
            })
            this.$emit('emit', {
              action: 'select',
              data: {
                item: this.$props.item,
                event: e
              }
            })
          }
        }
      }
    },
    drop: function () {
      this.$set(this.config.status, 'dragovering', false)
      if (this.$props.item) {
        this.$emit('emit', {
          action: 'move',
          data: this.$props.item
        })
      }
    },
    dragstart: function (e) {
      this.$set(this.config.status, 'dragging', true)
      this.$emit('emit', {
        action: 'dragstart',
        data: e
      })
    },
    dragend: function () {
      this.$set(this.config.status, 'dragging', false)
    },
    dragover: function () {
      if (
        this.$props.status &&
        this.$props.status.dragging &&
        !this.config.status.selecting
      ) {
        this.$set(this.config.status, 'dragovering', true)
      }
    },
    dragleave: function () {
      this.$set(this.config.status, 'dragovering', false)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isActive () {
      return !!(
        this.$props.item &&
        this.$props.item.active
      )
    },
    isLocked () {
      return !!(
        this.$props.item &&
        this.$props.item.tags &&
        this.$props.item.tags.authed
      )
    },
    isSetClientId () {
      return !!this.$props.cid
    },
    isAuthed () {
      return this.$props.authed && !(
        this.$props.item.tags &&
        this.$props.item.tags.authed &&
        this.$props.item.tags.authed !== this.$store.getters['author/get']('userid')
      )
    },
    isTrashed () {
      return this.$props.trashed
    },
    isShared () {
      return !!(
        this.$props.item &&
        this.$props.item.tags &&
        this.$props.item.tags.shared
      )
    },
    isSharedDirectory () {
      return this.$props.shared
    },
    isItemLoading () {
      return (
        this.$props.item &&
        this.$props.item.status &&
        this.$props.item.status.loading
      )
    },
    isCoreLoading () {
      return this.$props.status && this.$props.status.loading
    },
    isCoreDragging () {
      return !!(
        this.$props.status &&
        this.$props.status.dragging
      )
    },
    isDragovering () {
      return this.config.status.dragovering
    },
    isSelecting () {
      return this.config.status.selecting
    },
    isInserted () {
      return (
        this.$props.item &&
        this.$props.item.status &&
        this.$props.item.status.inserting
      )
    },
    isDragovered () {
      return (
        this.$props.item &&
        this.$props.item.status &&
        this.$props.item.status.dragovering
      )
    },
    printAuthor () {
      return (
        this.$props.item &&
        this.$props.item.tags &&
        this.$props.item.tags.authed
      ) ? this.$props.item.tags.authed : ''
    },
    printName () {
      if (this.$props.item && this.$props.item.name) {
        if (this.$props.trashed) {
          let nameInfo = this.$props.item.name.split('_')
          let date = nameInfo.shift()
          return '（' + this.$moment(date).format('YYYY年MM月DD日') + ' 削除）' + nameInfo.join('_')
        } else {
          return this.$props.item.name
        }
      } else {
        return ''
      }
    },
    printModifiedAt () {
      return (
        this.$props.item &&
        this.$props.item.modified_at
      ) ? this.$moment(this.$props.item.modified_at).format('YYYY年MM月DD日') : ''
    },
    printSize () {
      return (
        this.$props.item &&
        this.$props.item.size
      ) ? (this.$props.item.size + ' B') : ''
    }
  }
}
</script>

<style lang="scss">
.filer {
  .folder {
    .name-link {
      outline: 0 !important;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
